var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapeImageBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 600,
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n  .st1{fill:#1240AB;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(300,300)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M103.9,-130C136.1,-119.6,164.6,-91.2,192.6,-51.6C220.6,-11.9,248.2,38.8,237.8,79.2C227.4,119.6,178.9,149.6,133,177.5C87,205.4,43.5,231.2,-3.2,235.7C-50,240.1,-99.9,223.2,-123.2,187.9C-146.5,152.7,-143.2,99.1,-158.1,51.7C-173.1,4.3,-206.4,-36.8,-205.1,-74.7C-203.9,-112.6,-168.1,-147.3,-128.1,-155.2C-88.2,-163,-44.1,-144,-4.1,-138.3C35.9,-132.7,71.7,-140.4,103.9,-130Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeImageBg);
export default __webpack_public_path__ + "static/media/shape-image-bg.2c320fcbb1f10a792b40a68e767d716e.svg";
export { ForwardRef as ReactComponent };